// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"ba67da1b","370":"488afa52","462":"820173fe","498":"ccee8bcf","729":"fb8376b0","978":"f84e56c5"}[chunkId] + ".chunk.css";
};